// Generated from Swagger on 2025-08-27T14:46:24.204Z

export enum UserInfoUserType {
  INTERNAL_USER = "internal-user",
  CUSTOMER_USER = "customer-user",
}

export enum UserInfoUserRole {
  ADMIN = "ADMIN",
  USER = "USER",
}

export interface UserOnboardingProgressStepResponseDto {
  key: string;
  title: string;
  url: string;
  completed: boolean;
}

export interface UserOnboardingProgressResponseDto {
  completedStepsCount: number;
  totalSteps: number;
  progressPercentage: number;
  currentStep: UserOnboardingProgressStepResponseDto;
  steps: UserOnboardingProgressStepResponseDto[];
}

export interface UserInfoResponseDto {
  _id: string;
  organizationId?: string;
  sub: string;
  firstName: string;
  lastName: string;
  userType: UserInfoUserType;
  userRole: UserInfoUserRole;
  organizationName: string;
  logoUrl?: string;
  departments: string[];
  permissions?: string[];
  subscriptionStatus?: string;
  subscriptionType?: string;
  accessUntil?: string; // Date string from backend
  hasUsedTrial?: boolean;
  hasStripeId?: boolean;
  onboardingProgress?: UserOnboardingProgressResponseDto;
}

export interface ErrorDto {
  message: string;
  error: string;
  statusCode: number;
}

export interface UpdateMailRequestDto {
  mail: string;
}

export interface UserProfileResponseDto {
  _id: string;
  firstName: string;
  lastName: string;
  mail: string;
}

export interface ResetPasswordRequestDto {
  mail: string;
}

export interface CompleteProfileRequestDto {
  firstName: string;
  lastName: string;
}
